import React from "react";
import { useAlertMessageActionsContext } from "../../Context/AlertMessageContext";

function AlertMessage(props) {
  const { showAlertMessage, isAlertSuccess, alertmessage } = props;
  const { setAlertMessageFromAPI } = useAlertMessageActionsContext();

  let _class = "";
  _class = isAlertSuccess
    ? "alert alert-success alert-dismissible fade show text-center"
    : "alert alert-danger alert-dismissible fade show text-center";

  function resetState() {
    setAlertMessageFromAPI(false, false, "");
  }

  return (
    <>
      {showAlertMessage && (
        <div
          className="container"
          style={{
            maxWidth: "max-content",
            // position: "absolute",
            // marginLeft: "50%",
            // marginTop: "5%",
          }}
        >
          <div className={_class} role="alert">
            {alertmessage}
            <button
              type="button"
              className="close"
              data-dismiss="alert"
              aria-label="Close"
              onClick={resetState}
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
        </div>
      )}
    </>
  );
}

export default AlertMessage;
